<template>
  <Btn :label="label" color="error" :disabled="disabled" @click="onClick" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnInvalid',
  components: {
    Btn,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0537')
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
